// src/Footer.js
import React from 'react';
import { Link } from 'react-router-dom'; // Import Link
import { Typography, Box } from '@mui/material';

function Footer() {
    return (
        <Box
            component="footer"
            sx={{
                py: 3,
                px: 2,
                mt: 'auto',
                backgroundColor: (theme) =>
                    theme.palette.mode === 'light'
                        ? theme.palette.grey[200]
                        : theme.palette.grey[800],
            }}
        >
            <Typography variant="body2" color="text.secondary" align="center">
                {'Copyright © '}
                Radian, a project of <Link to="https://www.m2powered.com" className="footer-link">Mandel Management Solutions</Link> {new Date().getFullYear()}.  All Rights Reserved
                {'.'}
            </Typography>
        </Box>
    );
}

export default Footer;